import Button from "../../components/Button";
import { TrackingUtil } from "../../utils/tracking";import { DataType, DataListType, IWidget, ACTION_VARIANT } from "../../types";
import { DOM } from "../../utils/domActions";

class SlideList implements IWidget {
    container: HTMLElement | null = null;
    listData: DataListType | null = null;
    items: DataType[] = [];
    campaignId: string | null = null;    
    render(): HTMLElement {
        if (!this.container) {
            this.container = DOM.createElement("div", {
                id: "trustshop-embed-slide-list--container",
                className: "trustshop-embed-slide-list--container",
            });
        }

        // Create slides container
        const slidesContainer = DOM.createElement("div", {
            className: "trustshop-embed-slide-list--slides",
        });

        this.items.forEach((data) => {
            const slide = this.renderSlide(data);
            slidesContainer.appendChild(slide);
        });

        this.container.appendChild(slidesContainer);

        return this.container;
    }

    renderSlide(data: DataType): HTMLElement {
        const slide = DOM.createElement("div", {
            className: "trustshop-embed-slide-list--slide",
        });

        // Slide inner wrapper
        const slideInner = DOM.createElement("div", {
            className: "trustshop-embed-slide-list--slide-inner",
        });

        // Content section on the left
        const contentSection = DOM.createElement("div", {
            className: "trustshop-embed-slide-list--slide-content",
        });

        // Title
        if (data.title) {
            const title = DOM.createElement("h3", {
                className: "trustshop-embed-slide-list--slide-title",
                textContent: data.title,
            });
            contentSection.appendChild(title);
        }

        // Date
        if (data.date) {
            const date = DOM.createElement("span", {
                className: "trustshop-embed-slide-list--slide-date",
                textContent: data.date,
            });
            contentSection.appendChild(date);
        }

        // Description
        if (data.description) {
            const description = DOM.createElement("p", {
                className: "trustshop-embed-slide-list--slide-description",
                textContent: data.description,
            });
            contentSection.appendChild(description);
        }

        // Actions
        if (data.primary_action || data.secondary_actions) {
            const actionsContainer = DOM.createElement("div", {
                className: "trustshop-embed-slide-list--slide-actions",
            });

            // Primary action
            if (data.primary_action) {
                const actionBtn = Button.create({
                    ...data.primary_action,
                    variant: data.primary_action.variant || ACTION_VARIANT.PRIMARY,
                    className: "trustshop-embed-slide-list--slide-action",
                });
                actionsContainer.appendChild(actionBtn);
            }

            // Secondary actions
            if (data.secondary_actions) {
                const secondaryActions = Array.isArray(data.secondary_actions) 
                    ? data.secondary_actions 
                    : [data.secondary_actions];

                secondaryActions.forEach((action) => {
                    const actionBtn = Button.create({
                        ...action,
                        variant: action.variant || ACTION_VARIANT.PLAIN,
                        className: "trustshop-embed-slide-list--slide-secondary",
                    });
                    actionsContainer.appendChild(actionBtn);
                });
            }

            contentSection.appendChild(actionsContainer);
        }

        slideInner.appendChild(contentSection);

        // Image section on the right
        if (data.img_url) {
            const imageSection = DOM.createElement("div", {
                className: "trustshop-embed-slide-list--slide-image",
            });

            const img = DOM.createElement("img", {
                attributes: {
                    src: data.img_url,
                    alt: data.title || "Slide image",
                },
            });
            imageSection.appendChild(img);
            slideInner.appendChild(imageSection);
        }

        slide.appendChild(slideInner);
        return slide;
    }

    show(): void {
        if (this.container) {
            this.container.style.display = "block";
        }
    }

    hide(): void {
        if (this.container) {
            this.container.style.display = "none";
        }
    }

    destroy(): void {
        if (this.container) {
            this.container.remove();
            this.container = null;
        }
    }

    isVisible(): boolean {
        return this.container ? this.container.style.display !== "none" : false;
    }

    toggle(): void {
        if (this.isVisible()) {
            this.hide();
        } else {
            this.show();
        }
    }

    updateData(data: DataListType | DataType | DataType[]): void {
        // Check if it's a DataListType with title, subtitle, and data array
        if (data && "data" in data && Array.isArray(data.data)) {
            // Store the full DataListType object
            this.listData = data as DataListType;
            this.items = data.data.filter(Boolean) as DataType[];
        } else if (Array.isArray(data)) {
            // Direct array of items
            this.items = data;
            this.listData = null;
        } else {
            // Single item, wrap in array
            this.items = [data as DataType];
            this.listData = null;
        }
    }
}

const SlideListInstance = new SlideList();

export default SlideListInstance;